import { ref } from 'vue'

export function useClipboard() {
  const isSupported = ref(navigator && 'clipboard' in navigator)
  const isCopied = ref(false)
  const isLoading = ref(false)

  const copy = async (text) => {
    if (!isSupported.value) {
      console.warn('Clipboard API not supported')
      return false
    }

    isLoading.value = true

    try {
      await navigator.clipboard.writeText(text)
      isCopied.value = true

      // 自動重置狀態
      setTimeout(() => {
        isCopied.value = false
      }, 2000)

      return true
    } catch (error) {
      console.error('Failed to copy to clipboard:', error)
      return false
    } finally {
      isLoading.value = false
    }
  }

  return {
    isSupported,
    isCopied,
    isLoading,
    copy
  }
}